import { Button, Col, Image, Row } from 'antd'
import React, { useState } from 'react'
// import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import { openInNewTab } from './commonFunc'
// import { backtotopFunctionInstant } from "./BacktoTop";

import webProjectList from '../data/projects_web'

const ProjectList = () => {

  const [worksType, setWorksType] = useState("web")
  return (
    <div className='mainContent'>
      <h1 className="contentTitle undraggable">Selected Works : {worksType === "web" ? <label className="contentTitle" style={{textDecoration:"underline"}} >Websites</label> : worksType === "game" ? <label className="contentTitle" style={{textDecoration:"underline"}} >Games Development</label> : null}</h1>
      <Row className="margin-btm-12">
          <Col style={{ margin: '0 12px' }} className="infoCol">
            <motion.div
              transition={{ ease: 'easeIn', duration: 0.1 }}
              whileTap={{ scale: 0.9, zIndex: 1 }}
            >
              <Button type='primary' 
              disabled={worksType === "web"&& true}
              style={{backgroundColor:worksType === "web" && "rgb(35, 83, 173)",color:worksType === "web" &&"grey"}}
              href='#/'
                // className={worksType === 'Skills' ? classes.text_skills_active : classes.text_skills}
                onClick={() => setWorksType('web')}
              >
                Websites
              </Button>
            </motion.div>
          </Col>

          <Col style={{ margin: '0 12px' }}>
            <motion.div
              transition={{ ease: 'easeIn', duration: 0.1 }}
              whileTap={{ scale: 0.9, zIndex: 1 }}
            >
              <Button   type='primary' 
              href='#/'
              // className={worksType === 'game' ? classes.text_skills_active : classes.text_skills} 
              style={{backgroundColor:worksType === "game" && "rgb(35, 83, 173)",color:worksType === "game" &&"grey"}}
              onClick={() => setWorksType('game')}
              >
                Game Dev
              </Button>
            </motion.div>
          </Col>

        </Row>

      {worksType === "web" ?
        webProjectList.toReversed().map((val, i) => {
          if (val.show === true)
            return (
              <motion.div
                initial={{ x: 0, opacity: 0 }}
                key={i}
                // animate={{ ease: 'easeIn', duration: 0.8, delay: 0.5 }}
                whileInView={{ opacity: [0, 1], x: [-100, 0] }}
                viewport={{ once: true }}
              >
                <motion.div className="carouselContainer"
                  transition={{ ease: 'easeIn', duration: 0.6 }}
                  whileInView={{ x: [-25, 0] }}
                >
                  <p className="projectTitle color-white-smoke">{val.title + " - " + val.date + " "}

                    {val.link !== "" ?(
                      <motion.a
                        key={i}
                        whileTap={{ scale: 0.9 }}
                        whileHover={{
                          scale: 1.2,
                          transition: { duration: 0.1 },
                        }}
                        onClick={() => openInNewTab(val.link)}
                      >
                        live view
                      </motion.a>

                    ):null}
                  </p>
                  {val.imgList && (
                    <Row>
                      <Image.PreviewGroup >
                        {val.imgList.map((index, i) => (
                          <Col span={window.innerWidth > 450 ? 8 : 24} key={i + index}>
                            <Image
                              key={i + index}
                              src={index.img}
                              className="gridProjectItem"
                              alt="noImg"
                            />
                          </Col>
                        ))}
                      </Image.PreviewGroup>
                    </Row>
                  )}
                </motion.div>
              </motion.div>
            )
          else return null;
        })
        : 
        worksType === "game" ? 
          (
            <motion.div
                initial={{ x: 0, opacity: 0 }}
                // animate={{ ease: 'easeIn', duration: 0.8, delay: 0.5 }}
                whileInView={{ opacity: [0, 1], x: [-100, 0] }}
                viewport={{ once: true }}
              >
                <motion.div className="carouselContainer"
                  transition={{ ease: 'easeIn', duration: 0.6 }}
                  whileInView={{ x: [-25, 0] }}
                >
                  <h2 className="projectTitle color-white-smoke">{webProjectList[0].title + " - " + webProjectList[0].date + " "}

                    {webProjectList[0].link && (
                      <motion.a
                        whileTap={{ scale: 0.9 }}
                        whileHover={{
                          scale: 1.2,
                          transition: { duration: 0.1 },
                        }}
                        onClick={() => openInNewTab(webProjectList[0].link)}
                      >
                        link preview
                      </motion.a>

                    )}
                  </h2>
                  {webProjectList[0].imgList && (
                    <Row>
                      <Image.PreviewGroup >
                        {webProjectList[0].imgList.map((index, i) => (
                          <Col span={window.innerWidth > 450 ? 8 : 24} key={i + index}>
                            <Image
                              key={i + index}
                              src={index.img}
                              className="gridProjectItem"
                              alt="noImg"
                            />
                          </Col>
                        ))}
                      </Image.PreviewGroup>
                    </Row>
                  )}
                </motion.div>
              </motion.div>
          )
        : null
      }

    </div>
  )
}

export default ProjectList
